import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../servicios/auth.service';
import { environment } from '~environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate /*, CanActivateChild, CanDeactivate<unknown>, CanLoad*/ {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate(): boolean {
    const url = environment.dbUsed === 'Pruebas' ? 'https://accounts.qa.triidy.com' : 'https://accounts.triidy.com';
    if (this.auth.estaAutenticado()) {
      if (this.auth.leerVersion() === 'SI') {
        console.log('Version SI', this.auth.leerVersion())
        window.open(url, '_blank')
        return false;
      } else {
        return true;
      }
    } else {
      this.router.navigateByUrl('/iniciar-sesion');
      return false;
    }
  }

  /*canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }*/
}
